/**
 * FacetWP
 */

// Modified code from Plugin Name: FacetWP - Submit button - anchor to spesific tab added based on user selection
document.addEventListener("DOMContentLoaded", (event) => {

  jQuery(function() {
    jQuery(document).on('click', '.fwp-submit', function() {
      FWP.parseFacets();

      var href = jQuery(this).attr('data-href');
      var query_string = FWP.buildQueryString();

      if (query_string.length) {
          var prefix = (-1 < href.indexOf('?')) ? '&' : '?';
          href += prefix + query_string;
      }

      var anchor = '';
      var active_filter = jQuery('.property-search__submit-filter-button.active').attr('id');

      if (active_filter == 'submit-filter-map') {
        anchor = '#kartta';
      }

      if (this.id == 'submit-filter-map') {
        jQuery(submit_button).attr("data-href", '/kohteet#kartta');

      } else if (this.id == 'submit-filter-list') {
        jQuery(submit_button).attr("data-href", '/kohteet#lista');
      }

      window.location.href = href  + anchor;
  });
  });

});
